import React, { useContext } from 'react';
import useStyles from './styles';
import { AuthContext } from "../../../context/Auth/AuthContext";

function PaymentDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { firstName, zipcode, plan } = formValues;
  const { user } = useContext(AuthContext);


  const newPlan = JSON.parse(plan);
  const { price } = newPlan;

  const rows = [
    ['Email', user.email],
    ['Nome', firstName],
    ['CPF/CNPJ', zipcode]
  ];

  return (
    <div className={classes.block}>
      <h4 className={classes.title}>Informação de pagamento</h4>
      <dl className={classes.rows}>
        {rows.map(([term, value]) => (
          <div className={classes.row} key={term}>
            <dt className={classes.term}>{term}</dt>
            <dd className={classes.value}>{value}</dd>
          </div>
        ))}
        <div className={`${classes.row} ${classes.totalRow}`}>
          <dt className={classes.term}>Total</dt>
          <dd className={classes.value}>R${price.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</dd>
        </div>
      </dl>
    </div>
  );
}

export default PaymentDetails;
